module.exports = __webpack_public_path__ + "static/media/bestcamp-logo.15870498.svg";